import React from 'react'
import Video from '../components/Video/Video'
import Video1 from '../components/Video1/Video1'

const Videos = () => {
  return (
    <div className='videos'>
        <Video/>
        <Video1/>
    </div>
  )
}

export default Videos